export const GHP_TO_RHP_DURATION = 'ghpToRhpDuration'
export const SEARCH_CORE_RESULTS_DURATION = 'searchCoreResultsDuration'
export const SEARCH_PAGE_RESULTS_DURATION = 'searchPageResultsDuration'
export const MULTI_STORE_SEARCH_PAGE_RESULTS_DURATION = 'multiStoreSearchPageResultsDuration'
